import { useEffect } from "react";
import "@/App.css";
import Landing from "./pages/Landing";
import { Toaster } from "sonner";

function App() {
    useEffect(() => {
        // Observer for fade-up animations on scroll
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in-view");
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 },
        );
        document
            .querySelectorAll(".fade-up")
            .forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);

    return (
        <div className="App">
            <Landing />
            <Toaster
                position="top-right"
                richColors
                toastOptions={{
                    style: { fontFamily: "Manrope, sans-serif" },
                }}
            />
        </div>
    );
}

export default App;
